const DEFAULT_LOCALE = "zh-TW";

const BANNER_FIELD_PRIORITY = {
  "zh-TW": {
    title: ["title", "subTitle", "bakTitle"],
    subtitle2: ["subTitle2", "bakSubTitle2"],
    description: ["description", "subDescription", "bakDescription"],
    linkUrl: ["linkUrl", "subLinkUrl"],
  },
  en: {
    title: ["subTitle", "title", "bakTitle"],
    subtitle2: ["subTitle2En", "subTitle2"],
    description: ["subDescription", "description", "bakDescription"],
    linkUrl: ["subLinkUrl", "linkUrl"],
  },
  ko: {
    title: ["bakTitle", "title", "subTitle"],
    subtitle2: ["subTitle2Ko", "subTitle2"],
    description: ["bakDescription", "description", "subDescription"],
    linkUrl: ["subLinkUrl", "linkUrl"],
  },
};

function normalizeLocale(locale) {
  if (locale === "en" || locale === "ko") {
    return locale;
  }
  return DEFAULT_LOCALE;
}

function pickBannerField(item, fieldName, locale) {
  const normalizedLocale = normalizeLocale(locale);
  const fieldPriority = BANNER_FIELD_PRIORITY[normalizedLocale][fieldName] || [];

  for (const key of fieldPriority) {
    const value = item && typeof item[key] === "string" ? item[key].trim() : "";
    if (value) {
      return value;
    }
  }

  return "";
}

export function normalizeBannerItem(item, locale) {
  return {
    ...item,
    displayTitle: pickBannerField(item, "title", locale),
    displaySubTitle2: pickBannerField(item, "subtitle2", locale),
    displayDescription: pickBannerField(item, "description", locale),
    displayLinkUrl: pickBannerField(item, "linkUrl", locale),
  };
}

export function normalizeBannerList(list, locale) {
  if (!Array.isArray(list)) {
    return [];
  }
  return list.map((item) => normalizeBannerItem(item, locale));
}
